import { DEFAULT_CURRENCY_CODE, DEFAULT_CURRENCY_LABEL } from "../../utilities/currencyUtils";

const initial_state = {
  receipt_metadata: null,
  companyInfo: null,
  currencyCode: DEFAULT_CURRENCY_CODE,
  currencyLabel: DEFAULT_CURRENCY_LABEL,
};

const companyInfoReducer = (state = initial_state, action) => {
  switch (action.type) {
    case "RECEIPT_METADATA":
      console.log(action);
      return Object.assign({}, state, {
        receipt_metadata: action.receipt_metadata,
      });
    case "PUT_RECEIPT_METADATA":
      return {
        ...state,
        receipt_metadata: action.receipt_metadata,
      };

    case "SET_COMPANY_INFO":
      return {
        ...state,
        companyInfo: action.companyInfo ?? null,
        currencyCode: action.currencyCode || state.currencyCode || DEFAULT_CURRENCY_CODE,
        currencyLabel: action.currencyLabel || state.currencyLabel || DEFAULT_CURRENCY_LABEL,
      };

    case "CLEAR_COMPANY_INFO":
      return initial_state;

    default:
      return state;
  }
};

export default companyInfoReducer;
